module.exports = __webpack_public_path__ + "static/walter-f676e6d8056bdc84837bd42effd6a2de.svg";